const ICON_WIDTH_PX = 34;
const SCROLL_START_THRESHOLD = 10;

export function getActiveTabMarginLeft({ tabsWrapperElement, tabsItemsElement, activeTabElement }) {
    const containerWidth = tabsWrapperElement.getBoundingClientRect().width;
    const activeTabLeftAbsolute = activeTabElement.getBoundingClientRect().left;
    const activeTabWidth = activeTabElement.getBoundingClientRect().width;
    const activeTabLeft = activeTabLeftAbsolute - tabsItemsElement.getBoundingClientRect().left;

    return (containerWidth - activeTabWidth) / 2 - activeTabLeft;
}

export function getAdaptiveSettings({ tabsWrapperElement, tabsItemsElement, tabsMarginLeft }) {
    const containerWidth = tabsWrapperElement.getBoundingClientRect().width;
    const tabsWidth = tabsItemsElement.getBoundingClientRect().width;
    const maxTabsWidth = ICON_WIDTH_PX * 1.5 + tabsWidth;

    const isAdaptiveMode = maxTabsWidth > containerWidth;

    if (tabsMarginLeft > 0) {
        tabsMarginLeft = 0;
    }
    if (tabsMarginLeft + maxTabsWidth < containerWidth) {
        tabsMarginLeft = containerWidth - maxTabsWidth;
    }

    let showLeftGlare = tabsMarginLeft < 0;
    let showRightGlare = tabsMarginLeft + maxTabsWidth > containerWidth;

    if (!isAdaptiveMode) {
        tabsMarginLeft = 0;
        showLeftGlare = false;
        showRightGlare = false;
    }

    return {
        isAdaptiveMode,
        tabsMarginLeft,
        showLeftGlare,
        showRightGlare,
    };
}

export function isScrollExceedsThreshold(startX, event) {
    const currentX = getClientX(event);
    return Math.abs(startX - currentX) > SCROLL_START_THRESHOLD;
}

export function getClientX(event) {
    if (['touchstart', 'touchmove'].includes(event.type) && event.touches) {
        return event.touches[0].clientX;
    }

    return event.clientX;
}
